import { render, staticRenderFns } from "./Editar-Evento.vue?vue&type=template&id=dfec4262&scoped=true&"
import script from "./Editar-Evento.vue?vue&type=script&lang=js&"
export * from "./Editar-Evento.vue?vue&type=script&lang=js&"
import style0 from "./Editar-Evento.vue?vue&type=style&index=0&id=dfec4262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfec4262",
  null
  
)

component.options.__file = "Editar-Evento.vue"
export default component.exports